import { number, minValue, maxValue, maxLength, required } from 'react-admin';

export const validInteger = (value, allValues) => {
  if ( ((''+value).indexOf('.'))>=0 || ((''+value).indexOf('.'))>=0 ) {
    return 'Must be valid integer.';
  }
  return [];
}

export const validMaxLineSeparated = (values, max) => {
  if (values?.split('\n').length > max) return `Cannot be more than ${max} entries`;
}

export const validFrequencyCap = [number(), minValue(0), validInteger];
export const validFrequencyHours = [number(), minValue(0), maxValue(168), validInteger];

// The insights public API rejects a campaign name longer than this
// (routes/api/v1/validators.js, "at most 256 characters"), but the CONSOLE write
// path never checks length. Without this validator a console-created name can
// exceed what the API accepts, and a client that GETs the campaign and echoes it
// back is rejected on a field it never touched. Shared by both campaign forms so
// the two roles cannot drift from each other or from the API.
export const CAMPAIGN_NAME_MAX = 256;
export const validCampaignName = [required(), maxLength(CAMPAIGN_NAME_MAX)];

// NBI-20: a DIRECT campaign must keep at least one spend limit or the
// budget coordinator never allocates quota and it never serves.
export const requireSomeSpendLimit = (otherField) => (value, allValues) =>
  (Number(value) > 0 || Number(allValues && allValues[otherField]) > 0)
    ? undefined
    : 'Set an hourly or daily spend limit';